import { render, staticRenderFns } from "./selected-transaction.vue?vue&type=template&id=3bdb5126&"
import script from "./selected-transaction.vue?vue&type=script&lang=js&"
export * from "./selected-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports